export default "__VITE_ASSET__443fe145__"